import ky from 'ky';
import Notification from '@Common/Notification';
import { SUBSCRIPTION_HEADER_NAME } from '@Constants/constants';
import { API_TIMEOUT } from '@Helpers/apiConfig';

let _store;

export const pacerApiInjectStore = store => {
    _store = store;
}


export const createPacerApi = () => {
    if (!_store) {
        throw new Error(
            'pacerApi: Store has not been injected. Please call pacerApiInjectStore(store) before using createPacerApi().'
        );
    }
    const state = _store.getState();
    const token = state.user.accessToken;
    const subscriptionId = state.user.currentSubscriptionId;

    return ky.extend({
        timeout: API_TIMEOUT,
        retry: {
            limit: 2, // Retries 2 times (after initial failure)
            statusCodes: [404, 408, 429, 504],
            // delay: 1000, // Constant 1 second delay (overrides exponential)
            // backoffLimit: 30000, // Max delay of 30 seconds
            // jitter: true, // Add random jitter
            retryOnTimeout: true,
        },
        throwHttpErrors: false, // We'll handle HTTP errors manually (showing notifications, etc.)
        hooks: {
            beforeRequest: [
                (request, options, { retryCount }) => {
                    // Only set default auth header on initial request, not on retries (retries may have refreshed token set by beforeRetry)
                    if (retryCount === 0) {
                        request.headers.set('Authorization', `Bearer ${token}`);
                    }

                    if (subscriptionId) {
                        request.headers.set(SUBSCRIPTION_HEADER_NAME, subscriptionId.toString());
                    }
                }
            ],
            afterResponse: [
                // Retry with a fresh token on a 401 error
                // async (request, _options, response, state) => {
                //     if (response.status === 401 && state.retryCount === 0) {
                //         // Only refresh on first 401, not on subsequent retries
                //         const { token } = await ky.post('https://example.com/auth/refresh').json();

                //         const headers = new Headers(request.headers);
                //         headers.set('Authorization', `Bearer ${token}`);

                //         return ky.retry({
                //             request: new Request(request, { headers }),
                //             code: 'TOKEN_REFRESHED'
                //         });
                //     }
                // },

                // Show a notification for non-success status codes
                (request, options, response, state) => {
                    // Only show notification on the final retry attempt
                    const retry = options && options.retry;
                    const maxRetries = (retry && typeof retry.limit === 'number') ? retry.limit : 2;
                    const isFinalAttempt = state.retryCount >= maxRetries;
                    if ((response.status >= 300 || response.status < 200) && isFinalAttempt) {
                        console.error(`API request error: ${request.method} ${request.url} - Status: ${response.status} - Retry Count: ${state.retryCount}`);
                        response.clone().json()
                            .then((data) => {
                                Notification("error", "An Error Occurred", data.message);
                            })
                            .catch(error => {
                                console.error('Failed to parse error response JSON', error);
                                Notification("error", "An Error Occurred", "An unexpected error occurred.");
                            });
                    }
                }
            ]
        }
    });
}
